import * as React from 'react'
import { ReactElement } from 'react'
import BaseTagPicker, { BaseTagPickerProps, useBaseStyles } from './BaseTagPicker'
import { ActiveUserStatuses, UserListItemDto, UserStatus } from '../../config/userConfig'
import useUsers from '../../hooks/useUsers'
import useUser from '../../hooks/useUser'

export type UserPickerProps = Partial<BaseTagPickerProps<UserListItemDto>> &
    Required<Pick<BaseTagPickerProps<UserListItemDto>, 'selectedOptions' | 'onOptionsSelect'>>

export default function UserPicker(props: UserPickerProps): ReactElement {
    const styles = useBaseStyles()
    const { currentUser } = useUser()
    const { users } = useUsers()

    return (
        <BaseTagPicker<UserListItemDto>
            entities={users}
            filter={entity =>
                props.filter?.(entity) ??
                (currentUser?.id === entity.id || ActiveUserStatuses.includes(entity.status) || props.selectedOptions?.some(id => id === entity.id))
            }
            alphabetical
            getEntityLabel={user => user.fullName}
            getEntityTagLabel={user => user.fullName}
            getEntityValue={user => user.id}
            getEntityTagSecondaryContent={user => user.fullName}
            getEntityClassName={user => ([UserStatus.Disabled, UserStatus.Hidden].includes(user.status) ? [styles.archived] : [])}
            placeholderKey={'base.userpicker.placeholder'}
            {...props}
        />
    )
}
